module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/L77Loosefill-8d88ab99b446d8ea5a0bffdd8d80572b.png";